import { useState } from 'react'

import carbon from "../assets/carbon.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faInstagram, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { Link } from "@chakra-ui/react";
import { motion } from "framer-motion";

const listIcons = [
  { href: "https://github.com/rodolfo-code", icon: faGithub },
  { href: "https://www.linkedin.com/in/oliveira-rodolfo/", icon: faLinkedinIn },
  { href: "mailto:rod.vgo@gmail.com", icon: faEnvelope },
]

export default function Hiro() {

  const [loaded, setLoaded] = useState(true);

  return (
    <>
      {loaded ?
        <div
          className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white flex flex-col items-center justify-center"
        >Loading...</div>
        :
        null
      }
      <div id="home" className="pb-20 flex w-full h-auto flex-col md:flex-row gap-5 pt-48 md:pb-36 lg:pb-48 xl:pb-72 items-center justify-center text-white relative">

        <div className='md:w-3/6 md:p-4'>
          <img data-aos="flip-right" data-aos-duration="1500" data-aos-offset="200" src={carbon} alt="profile" onLoad={() => setLoaded(false)} />

        </div>
        <div className='md:w-3/6' data-aos="fade-right" data-aos-duration="1000" data-aos-offset="100" >
          <div className="flex flex-col w-full mt-8">
            <h1 className="text-xl text-gray-400">Hi, I'm</h1>
            <h1 className="text-2xl font-bold">Rodolfo Oliveira</h1>
            <p class="text-xl font-bold text-gray-300">Fullstack Developer</p>
            <p className="text-md font-light text-gray-400 ">Enthusiastic and motivated in IT. Interested in everything about Web Development, Front-end and back-end. Currently developing in React and learning .NET on demand. Aways looking for new experiences.</p>
          </div>


          <ul className='flex mt-2 gap-4 items-center'>
            {
              listIcons.map((item, index) => (
                <motion.div
                  whileHover={{
                    scale: 1.25
                  }}
                  whileTap={{ scale: 0.9 }}
                  key={index}
                >
                  <Link>
                    <a href={item.href} rel="noreferrer" target="_blank"><FontAwesomeIcon size='2xl' icon={item.icon} /></a>
                  </Link>
                </motion.div>
              ))
            }

          </ul>
        </div>


      </div>

    </>
  )
}
